/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DailyNavRecordUpdate = {
  readonly id?: number;
  readonly firm?: number;
  readonly company?: number;
  readonly date?: string;
  status?: DailyNavRecordUpdate.status | null;
  reviewed_by_scalar?: boolean;
  discussed_with_fund?: boolean;
  price_adjusted?: boolean;
  review_notes?: string | null;
  readonly measurement_date?: number | null;
  readonly last_modified_by?: number | null;
  readonly last_modified_at?: string | null;
  readonly created_at?: string;
  readonly updated_at?: string;
};
export namespace DailyNavRecordUpdate {
  export enum status {
    IN_PROGRESS = 'in_progress',
    REVIEWED = 'reviewed',
    RECOMMENDED = 'recommended',
    NOT_RECOMMENDED = 'not_recommended',
  }
}
